module.exports = __webpack_public_path__ + "static/assets/aa2cde26423a6b7445018f9890cd3f6b.svg";